package com.essntl.features.service.ui.components

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.wrapContentWidth
import androidx.compose.foundation.text.selection.SelectionContainer
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import com.essntl.toastmanager.ToastManager
import com.essntl.uikit.components.button.referenceCode.EsRefCodeButton
import com.essntl.uikit.components.iconbutton.outline.EsMediumOutlineIconButton
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography
import kotlinx.coroutines.launch
import org.koin.compose.koinInject

@Composable
fun ServiceHeaderSection(
    title: String,
    referenceCode: String?,
    onArrowClick: () -> Unit,
    showArrow: Boolean = true,
    headline: String? = null,
    modifier: Modifier = Modifier,
) {
    Row(
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(2.spacing),
        modifier = modifier.fillMaxWidth(),
    ) {
        if (showArrow)
            EsMediumOutlineIconButton(
                onClick = {
                    onArrowClick()
                },
                iconRes = EsIcons.ArrowRight,
            )

        Column(
            verticalArrangement = Arrangement.Center,
            horizontalAlignment = Alignment.Start,
            modifier = Modifier.weight(1f)
        ) {
            Row(
                horizontalArrangement = Arrangement.spacedBy(1.spacing),
                verticalAlignment = Alignment.CenterVertically,
                modifier = Modifier.fillMaxWidth()
            ) {
                Column(
                    modifier = Modifier.weight(1f)
                ) {
                    SelectionContainer {
                        Text(
                            text = title.trim().replaceFirstChar { it.uppercaseChar() },
                            maxLines = 2, // Ensures up to 2 lines for long titles
                            textAlign = TextAlign.Start,
                            color = MaterialTheme.esColorScheme.textPrimary,
                            style = MaterialTheme.esTypography.h565018,
                        )
                    }
                }

                referenceCode?.let { code ->
                    val toastManager = koinInject<ToastManager>()
                    val scope = rememberCoroutineScope()

                    Box(modifier = Modifier.wrapContentWidth()) {
                        EsRefCodeButton(
                            referenceCode = code,
                            onClicked = {
                                scope.launch {
                                    toastManager.success(
                                        title = "Service reference",
                                        description = "copied to clipboard",
                                    )
                                }
                            },
                        )
                    }
                }
            }

            headline?.let {
                if (it.isNotEmpty())
                    Text(
                        text = it,
                        style = MaterialTheme.esTypography.c1Medium13,
                        color = MaterialTheme.esColorScheme.textDisabled,
                    )
            }
        }
    }
}
